export default function isNil(data) {
  return data == null
}
